// extracted by mini-css-extract-plugin
module.exports = {"modalBtn":"styles_modalBtn__1OJN8","file":"styles_file__1PZuK"};